/** @format */

import { apiCache, CACHE_DURATION } from "@/lib/cache";
import api from "../interceptor";
import { AxiosResponse } from "axios";

const url = "/articles";
const storeID = process.env.NEXT_PUBLIC_STORE_ID || 1;

export const NewsAPI = {
  getNewsWithSlug: ({ slug }: { slug: string }) => {
    return api({
      method: "GET",
      url: `${url}/${slug}`,
    });
  },

  getNews: async ({
    currentPage,
    limit = 3,
  }: {
    currentPage: number;
    limit: number;
  }) => {
    return api({
      method: "GET",
      url: url,
      params: {
        currentPage,
        limit,
        storeId: storeID,
      },
    });
    // const cacheKey = `news_cache_page_${currentPage}`;
    // return await apiCache.getOrFetch<AxiosResponse>(
    //   cacheKey,
    //   CACHE_DURATION.FIVE_MINUTES,
    //   async () => {
    //     return api({
    //       method: "GET",
    //       url: url,
    //       params: {
    //         currentPage,
    //         limit,
    //         storeId: storeID,
    //       },
    //     });
    //   },
    // );
  },
};
